import { Box, Typography } from '@mui/material';
import Whale from '../../assets/images/whale.jpg';
import Swordfish from '../../assets/images/swordfish.png';
import Crocodile from '../../assets/images/alligator.jpg';
import RabbitHat from '../../assets/images/rabbitHat.jpg';
import MarchingBand from '../../assets/images/marching_band.jpg';
import Eagle from '../../assets/images/eagle.jpg';
import ThreeTeachers1 from '../../assets/images/3teachers1.png';
import ThreeTeachers2 from '../../assets/images/3teachers2.png';
import TwoTruckGuy from '../../assets/images/tow_truck_guy.png';
import Goldfish from '../../assets/images/fish_goldfish.jpg';
import StripedFish from '../../assets/images/fish_striped.jpg';
import FlowyFish from '../../assets/images/fish_flowy_fins.jpg';
import Sailboat from '../../assets/images/sailboat.png';
import { translate } from '../../../translations/translator';
const t = key => translate('worksheet', key);

const baseStyles: any = {
  fontFamily: 'Futura-Semibold',
  alignSelf: 'center'
};

const titleStyles: any = {
  fontSize: 20,
  paddingTop: '10px'
};

const subTitleStyles: any = {
  fontSize: 24,
  fontWeight: 'bold'
};

const imageOptions = {
  whale: Whale,
  swordfish: Swordfish,
  crocodile: Crocodile,
  eagle: Eagle,
  rabbitHat: RabbitHat,
  marchingBand: MarchingBand,
  teacher: ThreeTeachers1,
  teachers: ThreeTeachers2,
  twoTruckGuy: TwoTruckGuy,
  goldfish: Goldfish,
  stripedFish: StripedFish,
  flowyFinsFish: FlowyFish,
  sailboat: Sailboat
};

const renderImages = images => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
      }}
    >
      {images.map(image => {
        const img = imageOptions[image.name];
        const name = image.flipImage ? 'flippedImage' : 'image';
        return (
          <img
            style={{ height: image.height, width: image.width, margin: image.margin || '50px 0px' }}
            src={img}
            alt={t(image.name)}
            className={name}
          />
        );
      })}
    </Box>
  );
};

const CertificateImageBody = ({ completedTitle, images }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Typography style={{ ...titleStyles, ...baseStyles }}>
        {t('youCompleted')}{' '}
        <span style={{ fontFamily: 'Futura-Semibold-Italic' }}>{completedTitle}.</span>
      </Typography>
      <Typography style={{ ...subTitleStyles, ...baseStyles }}>{t('celebrateSentence')}</Typography>
      {renderImages(images)}
    </Box>
  );
};

export default CertificateImageBody;
